import CIcon from '@coreui/icons-react'
import {
    cilHouse,
    cilDescription,
    cilCalendar,
    cilCalendarCheck,
    cilSpeedometer,
    cilEducation,
    cilSearch,
    cilCommentSquare,
    cilMoney,
    cilNotes,
    cilHistory,
    cilTruck
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'

import Login from "./pages/Login";
import Files from "./pages/Files";
import TimeOffRequest from "./pages/timeOffRequest";
import TimeOffSummary from "./pages/timeOffSummary";
import DriverSummary from "./pages/DriverSummary";
import Home from "./pages/home";
import AdminSearch from './pages/AdminSearch';
import Policy from './pages/Policy';
import Feedback from './pages/feedback';
import ManagerCalendar from './pages/ManagerCalendar';
import Schedules from './pages/Schedules';
import Forms from './pages/Forms';
import ManagerSearch from './pages/ManagerSearch';
import ChangePassword from './pages/ChangePassword';
import SafetyMessages from './pages/SafetyMessages';
import Safety from './pages/Safety';
import SafetyMessageHistory from './pages/SafetyMessageHistory';    
import TrailerLocation from './pages/TrailerLocation';
import Permits from './pages/Permits';
import TimeOffDashboard from './pages/TimeOffDashboard'; // NEW
import MaintenanceForm from './pages/MaintenanceForm'; // NEW

const AppRoutes = [
    {
        name: 'Login',
        path: '/login',
        element: <Login />,
        requireAuth: false,
    },
    {
        name: 'Change Password',
        path: '/changePassword',
        element: <ChangePassword />,
        requireAuth: false,
    },
    {
        navBar: {
            component: CNavTitle,
            name: 'Home',
        },
        roles: ["driver", "admin", "dispatcher", "manager", "recruiting", "safety"]
    },
    {
        name: 'Home',
        path: '/home',
        element: <Home />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilHouse} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["driver", "admin", "dispatcher", "manager", "recruiting", "safety"]
    },
    {
        name: 'Safety Messages',
        path: '/safety',
        element: <SafetyMessages />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["driver"]
    },
    {
        navBar: {
            component: CNavTitle,
            name: 'Time Off',
        },
        roles: ["driver"],
        status: ["AVL"]
    },
    {
        name: 'Summary',
        path: '/timeOff/summary',
        element: <TimeOffSummary />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilCalendarCheck} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["driver"],
        status: ["AVL"]
    },
    {
        name: 'Request Time Off',
        path: '/timeOff/request',
        element: <TimeOffRequest />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["driver"],
        status: ["AVL"]
    },
    {
        navBar: {
            component: CNavTitle,
            name: 'Trailer Location',
        },
        roles: ["driver"],
        status: ["AVL"]
    },
    {
        name: 'Find My Trailer',
        path: '/trailer/find',
        element: <TrailerLocation />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilTruck} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["driver"],
        status: ["AVL"]
    },
    {
        navBar: {
            component: CNavTitle,
            name: 'Driver Documents',
        },
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"]
    },
    {
        name: 'Driver Documents',
        path: 'files/all',
        navBar: {
            component: CNavGroup,
            icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,

        },
        isParent: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"]
    },
    {
        name: 'All',
        path: '/files/all',
        element: <Files pageFilter="all" />,
        navBar: {
            component: CNavItem
        },
        parent: "Driver Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"]
    },
    {
        name: 'Pay Stub',
        path: '/files/payStub',
        element: <Files pageFilter="payStub" />,
        navBar: {
            component: CNavItem
        },
        parent: "Driver Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"],
        driverType: ["CO"]
    },
    {
        name: 'Settlements',
        path: '/files/settlements',
        element: <Files pageFilter="settlements" />,
        navBar: {
            component: CNavItem
        },
        parent: "Driver Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"]
    },
    {
        name: 'Maintenance',
        path: '/files/maintenance',
        element: <Files pageFilter="maintenance" />,
        navBar: {
            component: CNavItem
        },
        parent: "Driver Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"]
    },
    {
        name: 'Performance',
        path: '/files/performance',
        element: <Files pageFilter="performance" />,
        navBar: {
            component: CNavItem
        },
        parent: "Driver Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"]
    },
    {
        name: 'Tax Forms',
        path: '/files/yearlyStatements',
        element: <Files pageFilter="yearlyStatements" />,
        navBar: {
            component: CNavItem
        },
        parent: "Driver Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"]
    },
    {
        name: 'Tolls',
        path: '/files/tolls',
        element: <Files pageFilter="tolls" />,
        navBar: {
            component: CNavItem
        },
        parent: "Driver Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"]
    },
    {
        name: 'Fuel',
        path: '/files/fuel',
        element: <Files pageFilter="fuel" />,
        navBar: {
            component: CNavItem
        },
        parent: "Driver Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"]
    },
    {
        name: 'Other',
        path: '/files/other',
        element: <Files pageFilter="other" />,
        navBar: {
            component: CNavItem
        },
        parent: "Driver Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"]
    },
    {
        navBar: {
            component: CNavTitle,
            name: 'Company Documents',
        },
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"],
        status: ["AVL"]
    },
    {
        name: 'Company Documents',
        path: 'files/all',
        navBar: {
            component: CNavGroup,
            icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,

        },
        isParent: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"],
        status: ["AVL"]

    },
    {
        name: 'Policies',
        path: '/policies',
        element: <Policy />,
        navBar: {
            component: CNavItem,

        },
        parent: "Company Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"],
        status: ["AVL"]
    },
    {
        name: 'Forms',
        path: '/forms',
        element: <Forms />,
        navBar: {
            component: CNavItem,

        },
        parent: "Company Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"],
        status: ["AVL"]
    },
    {
        name: 'Schedules',
        path: '/schedules',
        element: <Schedules />,
        navBar: {
            component: CNavItem,

        },
        parent: "Company Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"],
        status: ["AVL"]
    },
    {
        name: 'Permits',
        path: '/permits',
        element: <Permits />,
        navBar: {
            component: CNavItem,

        },
        parent: "Company Documents",
        requireAuth: true,
        roles: ["driver", "dispatcher", "manager", "admin", "recruiting"],
        status: ["AVL"]
    },
    {
        navBar: {
            component: CNavTitle,
            name: 'Maintenance Form',
        },
        roles: ["driver"],
        status: ["AVL"],
        driverType: ["OO"]
    },
    {
        name: 'Maintenance Form',
        path: '/maintenance/form',
        element: <MaintenanceForm />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["driver"],
        status: ["AVL"],
        driverType: ["OO"]
    },
    {
        navBar: {
            component: CNavTitle,
            name: 'Useful Links',
        },
        roles: ["driver"],
        status: ["AVL"]
    },
    {
        name: 'Isaac',
        link: 'https://ct288.isaachosting.ca/IIRT/auth/login',
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["driver"],
        country: ["CAN"],
        status: ["AVL"]
    },
    {
        name: 'Samsara',
        link: 'https://cloud.samsara.com/signin_driver',
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["driver"],
        country: ["USA"],
        status: ["AVL"]
    },
    {
        name: 'CarriersEdge',
        link: 'https://www.carriersedge.com/',
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilEducation} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["driver"],
        country: ["CAN"],
        status: ["AVL"]
    },
    {
        name: 'Infinit-i',
        link: 'https://titaniumamerican.infinit-i.net/#/Login',
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilEducation} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["driver"],
        country: ["USA"],
        status: ["AVL"]
    },
    {
        name: 'Shareworks (SPP)',
        link: 'https://shareworks.solium.com/',
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilMoney} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["driver"],
        country: ["CAN"],
        status: ["AVL"]
    },
    {
        navBar: {
            component: CNavTitle,
            name: 'Admin',
        },
        roles: ["admin"]
    },
    {
        name: 'Search Requests',
        path: '/Admin/Search',
        element: <AdminSearch />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilSearch} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["admin"]
    },
    //{
    //    navBar: {
    //        component: CNavTitle,
    //        name: 'Dispatcher',
    //    },
    //    roles: ["dispatcher"]
    //},
    //{
    //    name: 'Pending Requests',
    //    path: '/dispatcher/requests',
    //    element: <DispatchPending />,
    //    navBar: {
    //        component: CNavItem,
    //        icon: <CIcon icon={cilCalendarCheck} customClassName="nav-icon" />,
    //    },
    //    requireAuth: true,
    //    roles: ["dispatcher"]
    //},
    //{
    //    name: 'Driver Calendar',
    //    path: '/dispatcher/calendar',
    //    element: <DispatchCalendar />,
    //    navBar: {
    //        component: CNavItem,
    //        icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
    //    },
    //    requireAuth: true,
    //    roles: ["dispatcher"]
    //},
    // {
    //     name: 'Update Request',
    //     path: '/updateRequest',
    //     element: <UpdateRequest />,
    //     requireAuth: false,
    //     // roles: ["Dispatcher"] ONLY NEEDED WHEN UPDATE REQUEST MOVED TO DISPATCH SIGN IN
    // },
    {
        navBar: {
            component: CNavTitle,
            name: 'Manager/Dispatcher',
        },
        roles: ["manager", "dispatcher"]
    },
    {
        name: 'Pending Requests',
        path: '/manager/requests',
        element: <ManagerSearch />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilCalendarCheck} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["manager", "dispatcher"]
    },
    {
        name: 'Driver Summary',
        path: '/manager/DriverSummary',
        element: <DriverSummary />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilCalendarCheck} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["manager", "dispatcher"],
    },
    {
        name: 'Driver Calendar',
        path: '/manager/calendar',
        element: <ManagerCalendar />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["manager", "dispatcher", "admin"]
    },
    {
        name: 'Time Off Dashboard',                       // NEW
        path: '/manager/timeoff-dashboard',              // NEW
        element: <TimeOffDashboard />,                   // NEW
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["manager", "dispatcher", "admin"]        // allow admins as well if you want
    },
    {
        navBar: {
            component: CNavTitle,
            name: 'Questions & Feedback',
        },
        roles: ["driver"]
    },
    {
        name: 'Submit Feedback',
        path: '/feedback',
        element: <Feedback />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilCommentSquare} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["driver"]
    },
    {
        navBar: {
            component: CNavTitle,
            name: 'Safety Team',
        },
        roles: ["safety", "admin", "recruiting"]
    },
    {
        name: 'Send Message',
        path: '/message/send',
        element: <Safety />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilCommentSquare} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["safety", "admin","recruiting"]
    },
    {
        name: 'Message History',
        path: '/message/history',
        element: <SafetyMessageHistory />,
        navBar: {
            component: CNavItem,
            icon: <CIcon icon={cilHistory} customClassName="nav-icon" />,
        },
        requireAuth: true,
        roles: ["safety", "admin", "recruiting"]
    },
];

export default AppRoutes;
